export default "__VITE_ASSET__BJz1AFBz__"